import React from "react";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import ImageIcon from "@mui/icons-material/Image";
import MovieIcon from "@mui/icons-material/Movie";
import PhotoSizeSelectSmallIcon from "@mui/icons-material/PhotoSizeSelectSmall";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import TwoKIcon from "@mui/icons-material/TwoK";
import { RowBox } from "../../../../utils/styledBox";
import FourKIcon from "@mui/icons-material/FourK";
import HdIcon from "@mui/icons-material/Hd";
import { Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const getActionIcon = (action: string) => {
  let icon: React.ReactNode = null;
  let text = "";
  let colorCode = "#C6E067"; // デフォルト色（青）

  switch (action) {
    case "i2v":
      icon = <ImageIcon sx={{ fontSize: "16px" }} />;
      text = "I2V";
      colorCode = "#1D523C";
      break;
    case "t2v":
      icon = <FontDownloadIcon sx={{ fontSize: "16px" }} />;
      text = "T2V";
      colorCode = "#271D52";
      break;
    case "v2v":
      icon = <MovieIcon sx={{ fontSize: "16px" }} />;
      text = "V2V";
      colorCode = "#72A791";
      break;
    case "upscale":
      icon = <PhotoSizeSelectSmallIcon sx={{ fontSize: "16px" }} />;
      text = "Upscale";
      colorCode = "#52251D";
      break;
    case "lipsync":
      icon = <RecordVoiceOverIcon sx={{ fontSize: "16px" }} />;
      text = "Lipsync";
      colorCode = "#524C1D";
      break;
    default:
      return null;
  }

  return (
    <Typography
      variant="body2"
      sx={{
        fontWeight: 600,
        px: 1,
        py: 0.2,
        borderRadius: "2px",
        display: "inline-flex",
        bgcolor: alpha(colorCode, 0.5),
        color: "#fff",
      }}
      component="span"
    >
      <RowBox gap={0.5}>
        {icon}
        <span>{text}</span>
      </RowBox>
    </Typography>
  );
};

export const getIcon = (version: string) => {
  if (version === "LATENTSYNC" || version === "LIPSYNC_190" || version === "LIPSYNC_V2") {
    return undefined;
  }
  if (
    version === "V3_5_1080P" ||
    version === "V3_5_TRANSITION_1080P" ||
    version === "V4_1080P" ||
    version === "V4_T2V_1080P" ||
    version === "V4_5_1080P" ||
    version === "V4_5_TRANSITION_1080P" ||
    version === "V1_5_PRO" ||
    version === "V1_6_PRO" ||
    version === "VIDU_2_0_1080P" ||
    version === "V2_1_PRO" ||
    version === "V2_1_MASTER" ||
    version === "RAY_2_1080P" ||
    version === "RAY_2_FLASH_1080P" ||
    version === "VIDU_2_0_START_END_1080P" ||
    version === "VIDU_Q1" ||
    version === "VIDU_Q1_START_END"
  ) {
    return <TwoKIcon fontSize="small" color="primary" />;
  }
  if (
    version === "REALESRGAN" ||
    version === "TOPAZ_VIDEO_UPSCALE" ||
    version === "RAY_2_4K" ||
    version === "RAY_2_FLASH_4K"
  ) {
    return <FourKIcon fontSize="small" color="success" />;
  }

  return <HdIcon fontSize="small" color="secondary" />;
};
